const classes = {
  active: 'is-active',
};

function Filter(filterSet) {
  const filters = filterSet.querySelectorAll('[data-js-filter]');
  const items = filterSet.querySelectorAll('[data-js-filter-item]');

  function setActive(el) {
    el.classList.add(classes.active);
  }

  function setNoResults() {
    setActive(filterSet.querySelector('#no-results'), false);
  }

  function setActiveTargets(checkNoResults = true) {
    // Filters are exclusive ie. Selecting 'Group program' and 'Online'
    // will only show the items that are in both those categories.
    let queryString = '';
    const activeFilters = filterSet.querySelectorAll(
      '[data-js-filter]:checked',
    );

    if (activeFilters.length === 0) {
      return;
    }

    [...activeFilters].forEach((el) => {
      queryString += `.filter-${el.getAttribute('data-js-filter')}`;
    });

    const targets = filterSet.querySelectorAll(queryString);

    [...items].forEach((item) => item.classList.remove(classes.active));
    [...targets].forEach((item) => item.classList.add(classes.active));

    if (checkNoResults && targets.length === 0) {
      setNoResults();
    }
  }

  function filter() {
    setActiveTargets();
  }

  function resetToAll() {
    [...filters].forEach((el) => {
      el.checked = false;
    });

    filterSet.querySelector('[data-js-filter="all"]').checked = true;
  }

  function addEventListeners(f) {
    f.forEach((el) => {
      el.addEventListener('change', (e) => {
        e.preventDefault();
        if (el.getAttribute('data-js-filter') === 'all') {
          resetToAll();
        }
        filter();
      });
    });
  }
  addEventListeners(filters);
}

export function init() {
  const filterSets = document.querySelectorAll('[data-js-filter-set]');
  if (filterSets.length) {
    [...filterSets].forEach((el) => {
      Filter(el);
    });
  }
}
